var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"col-lg-12 gp-campaign-report0 pt-2"},[_c('ReportModal',{attrs:{"campaign":_vm.details},on:{"close":_vm.goBack}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }